// Cretexa brand mark — orange scaffold-frame icon + wordmark
export default function Logo({ className = "", markSize = 30, showText = true, textClassName = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <svg
        width={markSize}
        height={markSize}
        viewBox="0 0 48 48"
        fill="none"
        stroke="#FF4D00"
        strokeWidth="3"
        strokeLinecap="square"
        aria-hidden="true"
        className="shrink-0"
      >
        {/* verticals */}
        <line x1="8" y1="6" x2="8" y2="42" />
        <line x1="40" y1="6" x2="40" y2="42" />
        {/* horizontal rails */}
        <line x1="6" y1="12" x2="42" y2="12" />
        <line x1="6" y1="30" x2="42" y2="30" />
        {/* diagonal cross brace between top and middle rail */}
        <line x1="8" y1="12" x2="40" y2="30" />
        <line x1="40" y1="12" x2="8" y2="30" />
      </svg>
      {showText && (
        <span className={`font-display font-black tracking-tighter uppercase leading-none ${textClassName}`}>
          Cretexa<span className="text-[#FF4D00]">.</span>
        </span>
      )}
    </span>
  );
}
